import { IDefineCommand } from 'core-ts-types';

angular
  .module('major-explorer-data')
  .factory('saveReminderAboutMajorsCommand', (defineCommand: IDefineCommand, $http: ng.IHttpService, log: any) => {
    return defineCommand('saveReminderAboutMajorsCommand', (deferred: ng.IDeferred<any>, flag: boolean) => {
      const payload = { has_advisor_reminder_about_majors: flag };
      $http
        .post('core/studentvalue/', payload)
        .then(() => {
          deferred.resolve(payload);
        })
        .catch((response) => {
          log.issue('Unable to udpate reminder, Please try again.');
          deferred.reject(response);
        });
    });
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/data/commands/save_reminder_about_majors_command.ts